import styled from "styled-components";
import { GeneralReviewsSvg } from "../../components/Assets";

const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px 20px;
  gap: 24px;
`;
export default function GeneralReviewNoData() {
  return (
    <Box  style={{
      marginTop: 100,
    }}>
      <img src={GeneralReviewsSvg}></img>
      <p className="flex flex-col gap-2">
        <b className="text-lg text-center">일반 리뷰가 없어요.</b>
        <span className="flex flex-col">
          <span className="text-center">
            스폰지 가입일 이전에 등록된 리뷰는 보이지 않아요.
          </span>
          <span className="text-center">
            가입일 이후의 리뷰가 보이지 않는 경우에는{" "}
          </span>
          <span className="text-center">검색 조건을 변경해보세요. </span>
        </span>
      </p>
    </Box>
  );
}
